import React from 'react';
import PropTypes from 'prop-types';
import styles from './WhiteBoxProgressIcon.scss';

const WhiteBoxProgressIcon = ({type, bigger, forceDisplay}) => {
	const additionalClass = bigger ? styles.bigger : '';
	if (!forceDisplay) {
		return null;
	}
	return (
		<div className={`${styles.container} ${styles[type]} ${additionalClass}`}/>
	);
};
WhiteBoxProgressIcon.defaultProps = {
	forceDisplay: false
}
WhiteBoxProgressIcon.propTypes = {
	type: PropTypes.oneOf(['success', 'error', 'progress', 'domains']).isRequired,
	bigger: PropTypes.bool,
	forceDisplay: PropTypes.bool,
};
export default WhiteBoxProgressIcon;